<template>
  <div class="invite-list" :class="language">
    <div class="invite-list-title">
      <div
        class="title-item"
        v-for="(item, index) in tabs"
        :key="item"
        @click="changeActive(index)"
      >
        <div
          :class="[
            'title-item-active',
            `title-item-active-${language}${index}`
          ]"
          v-if="active === index"
        ></div>
        <template v-else>
          {{ language === 'zh' ? tabZhs[index] : item }}
        </template>
      </div>
    </div>
    <ListScroll
      v-if="active === 0"
      class="rank-list week-rank-list"
      :listLen="weekRanks.length"
    >
      <div
        class="week-rank-item"
        v-for="(wRank, wIndex) in weekRanks"
        :key="wRank.id"
      >
        <div
          class="week-rank-index-icon"
          :class="`week-rank-index-icon-${wIndex}`"
          v-if="wIndex < 3"
        ></div>
        <div class="week-rank-index" v-else>{{ wIndex + 1 }}</div>
        <img class="avatar" :src="wRank.headUrl" />
        <div class="name text-ellipsis">{{ wRank.name }}</div>
      </div>
    </ListScroll>
    <div class="rank-list my-rank-list" v-else-if="myRanks.length">
      <div class="my-rank-wrap">
        <div
          class="week-rank-item"
          v-for="(mRank, mIndex) in myRanks"
          :key="mIndex"
        >
          <img class="avatar" :src="mRank.headUrl" />
          <div class="name text-ellipsis">{{ mRank.name }}</div>
          <div class="time">
            <span>{{ mRank.successTime }}</span>
          </div>
        </div>
      </div>
      <div class="total">
        {{
          language === 'zh'
            ? `累计奖励：${totalReward}钻石`
            : `جۇغلانغان مۇكاپات ${totalReward} ئالتۇن تەڭگە`
        }}
      </div>
    </div>
    <div class="rank-list my-rank-empty" v-else>
      <img
        class="empty-icon"
        src="~@/assets/invite/Empty_NoData_light@2x.png"
      />
      <div class="empty-text">
        {{
          language === 'zh'
            ? `快去邀请好友，获得钻石奖励吧~`
            : `تېزدىن دوستىڭىزنى تەكلىپ قىلىپ ئالتۇن تەڭگەقا ئېرىشىڭ`
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { appFunc_senToken } from '@/utils/bridge'
import { apiGetinviteWeekRanks, apiGetinviteMyRanks } from '@/api'
import { CommonModule } from '@/store/modules/common'
import ListScroll from './ListScroll.vue'

export default {
  props: {
    language: {
      type: String,
      default: 'zh'
    },
    weekRanks: {
      type: Array,
      default: () => []
    },
    myRanks: {
      type: Array,
      default: () => []
    },
    totalReward: {
      type: Number,
      default: 0
    }
  },
  components: {
    ListScroll
  },
  data() {
    return {
      active: 0,
      tabs: ['ھەپتىلىك تىزىملىك', 'مېنىڭ تەكلىپىم'],
      tabZhs: ['邀请周榜', '我的邀请']
      // weekRanks: [],
      // myRanks: [],
      // totalReward: 0
    }
  },
  async mounted() {
    // this.getWeekRanks()
    // console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', Date.now())
    // await this.getToken()
    // this.getMyRanks()
  },
  methods: {
    changeActive(index) {
      this.active = index
      const { aplus_queue } = window
      if (index == 0) {
        aplus_queue.push({
          action: 'aplus.record',
          arguments: ['lnvite_weekly_list', 'CLK']
        })
      } else {
        aplus_queue.push({
          action: 'aplus.record',
          arguments: ['my_invitation', 'CLK']
        })
      }
    },
    async getWeekRanks() {
      const { code, data } = await apiGetinviteWeekRanks()
      if (code === 1001) {
        this.weekRanks = data || []
      }
    },
    async getMyRanks() {
      const { code, data } = await apiGetinviteMyRanks()
      if (code === 1001) {
        this.totalReward = data.totalReward || 0
        this.myRanks = data.users || []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-list {
  padding-bottom: 40px;
  .invite-list-title {
    width: 339px;
    height: 44px;
    background: #ffffff;
    border-radius: 42px;
    margin: auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .title-item {
      width: 50%;
      text-align: center;
      font-family: ALIBABAPUHUITIBOLD;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 1px;
      background: linear-gradient(180deg, #fc6f37 0%, #f43a27 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .title-item-active {
      width: 197px;
      height: 79px;
      margin-left: -13px;
      &-zh0 {
        @include bg-image('invite/pic_an_xzh@2x');
      }
      &-zh1 {
        @include bg-image('invite/pic_an_xzh@2x(1)');
      }
      &-ug0 {
        @include bg-image('invite/pic_an_xzh@2x(2)');
      }
      &-ug1 {
        @include bg-image('invite/pic_an_xzh@2x(3)');
      }
    }
  }
  .rank-list {
    box-sizing: border-box;
    width: 339px;
    height: 423px;
    background: #ffffff;
    border-radius: 24px;
    border: 2px solid #fffed4;
    margin: 20px auto 0;
    padding: 20px 16px 0;
    .week-rank-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      &:last-child {
        border: none;
      }
      .name {
        width: 145px;
        font-size: 14px;
        font-weight: 500;
        color: #8a1822;
        line-height: 16px;
      }
    }
    .avatar {
      display: inline-block;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .week-rank-list {
    .week-rank-index {
      margin: 0 20px 0 15px;
      width: 26px;
      text-align: center;
      color: #8a1822;
    }
    .week-rank-index-icon {
      width: 26px;
      height: 38px;
      margin: 0 20px 0 15px;
      &-0 {
        @include bg-image('invite/pic_bd_01ac@2x');
      }
      &-1 {
        @include bg-image('invite/pic_bd_02@2x');
      }
      &-2 {
        @include bg-image('invite/pic_bd_03@2x');
      }
    }
  }
  .my-rank-list {
    padding-bottom: 40px;
    position: relative;
    overflow: hidden;
    .my-rank-wrap {
      height: 100%;
      overflow: auto;
    }
    .total {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 17px;
      text-align: center;
      font-size: 14px;
      color: #f53f29;
      line-height: 16px;
    }
    .week-rank-item {
      overflow: hidden;
      &:nth-last-child(2) {
        border: none;
      }
    }
    .time {
      flex: 1;
      text-align: right;
      color: #8a1822;
      span {
        width: 200%;
        display: inline-block;
        font-size: 20px;
        transform: scale(0.5);
        transform-origin: left;
      }
    }
  }
  .my-rank-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
    .empty-icon {
      display: inline-block;
      width: 180px;
      height: 160px;
      margin-bottom: 4px;
    }
    .empty-text {
      max-width: 275px;
      font-size: 14px;
      color: #5c5c5c;
      line-height: 16px;
    }
  }
}
</style>
